import type { SelectedDealership } from '../types';

/**
 * Parses a stored dealership JSON string from session storage.
 * Returns undefined if the value is empty or invalid JSON.
 */
export const parseStoredDealership = (stored: string | null): SelectedDealership | undefined => {
    if (!stored) return undefined;
    try {
        return JSON.parse(stored) as SelectedDealership;
    } catch {
        return undefined;
    }
};
